module.exports = __webpack_public_path__ + "img/grid-item-3.12914f66.jpg";